import { makeStyles } from '@material-ui/core/styles';

import { COLORS, VARIATION_DETAILS_PANEL_WIDTH } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      width: VARIATION_DETAILS_PANEL_WIDTH,
      height: '100%',
      overflowY: 'auto',

      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(7.5, 0),
      borderLeft: theme.shape.border,

      '&$gated': {
        padding: theme.spacing(3, 0, 7.5, 0),
      },
    },
    overlay: {
      position: 'fixed',
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: COLORS.neutral.darkGray,
      opacity: 0.7,
    },
    gated: {},
    variationFormat: {
      position: 'absolute',
      top: 18.75,
      left: 36,
    },
    buttonCollapse: {
      position: 'absolute',
      top: 6,
      right: 12,

      '& svg': {
        fontSize: theme.typography.pxToRem(24),
        color: theme.palette.common.black,
      },
    },
    textDetails: {},
  }),
  { name: 'VariationDetails' }
);
